/* global React */
import {
  IconButton as MuiIconButton, ListItemSecondaryAction, ListItemText, ListItemIcon,
} from '@mui/material'
import Icon from 'ui/Element/Icon'

const LocalIcon = props => (
  <Icon
    color={'primary'}
    {...props}
  />
)

const IconButton = props => (
  <MuiIconButton
    size={'small'}
    fontSize={'small'}
    color={'primary'}
    className={'material-icons-outlined'}
    {...props}
  />
)

const AttachmentListTemplateLocal = (props) => {
  const [progress, setProgress] = React.useState(false)
  const { file } = props
  // const { name } = file || {}
  const [name, setName] = React.useState(file.name || '')

  // adds file and callback to passed event
  const addEventDetail = (e) => {
    e.detail = {
      file,
      fn: setName,
    }
    return e
  }

  const onPlay = (e) => {
    setProgress(true)
    props.onClick(addEventDetail(e))
  }

  return (
    <>
      <ListItemIcon>
        <LocalIcon name={'paperclip'} />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          fontSize: 'large',
          color: 'primary',
        }}
      >
        { decodeURIComponent(name) }
      </ListItemText>
      <ListItemSecondaryAction>
        {
          progress
            ? <IconButton><LocalIcon name={'stop'}/></IconButton>
            : <IconButton onClick={onPlay}>
              <LocalIcon name={'play-circle'} />
            </IconButton>
        }
        <IconButton onClick={() => setProgress(false)}>
          <LocalIcon name={'clear'} />
        </IconButton>
      </ListItemSecondaryAction>
    </>
  )
}

export default AttachmentListTemplateLocal
